import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=65475b1c"
import script from "./ReportTable.vue?vue&type=script&lang=js"
export * from "./ReportTable.vue?vue&type=script&lang=js"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=65475b1c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports